import { render } from "./LoginView.vue?vue&type=template&id=61e8da48"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\dev\\Lipa-Digital-Labs\\dev\\Potsmunter\\mpt-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__